import store from "../redux";
import { v4 as uuidv4 } from "uuid";

import Leanplum from "leanplum-sdk";
import { setLeanplumStart } from "redux/actions/trackerAction";

function generateUserId() {
  const trackingId = uuidv4();
  localStorage.setItem("userId", trackingId);

  return trackingId;
}

export function leanplumTracker(eventName, params) {
  const { leanplumStart } = store.getState().trackerReducer;

  if (!leanplumStart) {
    const userId = localStorage.getItem("userId") || generateUserId();

    Leanplum.start(userId, function (success) {
      Leanplum.track(`event/${eventName}`, params);
    });

    store.dispatch(setLeanplumStart());
  } else {
    Leanplum.track(`event/${eventName}`, params);
  }
}
